import {
  Box,
  Text,
  Drawer,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Flex,
  Spinner,
  Avatar,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import IsDesktop from '../../utils/IsDesktop';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import ConnectionRequestTabs from '../connectionRequests/ConnectionRequestTabs';
import { useDispatch, useSelector } from 'react-redux';
// import { useData } from '../../data';
import { useNavigate } from 'react-router-dom';
import BrandButton from '../brandButton/BrandButton';
import { mutateFunction, useMutation } from '../../libs/apis';
import { setChatInfo } from '../../redux-toolkit/reducers/chatSlice';
import moment from 'moment';
import client from '../../libs/client';
import UserService from '../../utils/UserService';
import { setCurrentDealFlow, setCurrentTermSheetId } from '../../redux-toolkit/reducers/dealFlowSlice';
import { setTotalNotificationCount, setUnreads } from '../../redux-toolkit/reducers/userSlice';


const Notifications = ({ isOpen, onClose }) => {
  const isDesktop = IsDesktop();
  const navigate = useNavigate();
  const loggedInUserId = useSelector((state) => state?.user?.userInfo?.id);
  const { mutate, isLoading } = useMutation(mutateFunction);
  const dispatch = useDispatch();

  const [notifications, setNotifications] = useState([]);
  const [messageTracker, setMessageTracker] = useState({});
  const unreads = useSelector((state) => state?.user?.unreads);
  const totalNotificationCount = useSelector((state) => state?.user?.totalNotificationCount || 0);

  const goToLink = async (notificationId, link, type) => {
    let navigationLink;

    const wordTokens = type?.split('_');

    if (
      type === 'termsheet_submitted' ||
      type === 'termsheet_signed' ||
      type === 'termsheet_rejected'
    ) {
      try {
        // get deal data
        const linkArray = link.split('/');
        const dealId = linkArray[linkArray.length - 1];
        const response = await client().get(`deal-flow/${dealId}`);

        const dealData = response?.data?.data?.deal;
        dispatch(setCurrentDealFlow(dealData));
        UserService.setCurrentDealFlow(dealData);

        if (type === 'termsheet_submitted' || type === 'termsheet_rejected') {
          // get the termsheet id
          const termsheet_id = link.split("?")[1]?.split("=")[1];
          dispatch(setCurrentTermSheetId(termsheet_id));
          UserService.setCurrentTermSheetId(termsheet_id);
          navigationLink = "../view-term-sheet";
        } else {
          navigationLink = "../view-post-agreement-stage";
        }
      } catch (error) {
        console.error('Failed to fetch deal data:', error);
        readNotification(notificationId);
        return; // Don't navigate if the API call fails
      }
    } else if (type === 'comment') {
      const postId = link.split('/').pop();
      // Check if we're already on the feed page
      navigationLink = `/feed?postId=${postId}`;
    } else if (type === "founder_pipeline_deal_request") {
      navigationLink = `${link}?fromPipeline=true&createDeal=true`;
    } else if (wordTokens?.includes('pipeline')) {
      navigationLink = `${link}?fromPipeline=true`;
    } else {
      navigationLink = link;
    }

    onClose();
    readNotification(notificationId);
    navigate(navigationLink);

    // onClick={(e) => {
    //   goToUser(
    //     e,
    //     notification?.sender,
    //     notification.id,
    //   );
    // }}
  };

  const chatWithConnection = (user, notificationId, type = '') => {
    if (type == 'message') {
      for (let _id of messageTracker[user?.id]?.ids || []) {
        readNotification(_id);
      }
    } else {
      readNotification(notificationId);
    }

    //This can be problematic for unconnected users
    user.connectionMade = true;

    const numberOfCurrentMessages = unreads?.[user?.id]?.ids?.length || 0
    dispatch(setUnreads({
      ...unreads,
      [user?.id]: {
        count: 0,
        ids: [],
        senderIds: []
      }
    }))

    dispatch(setTotalNotificationCount(totalNotificationCount - numberOfCurrentMessages))
    UserService.setNotificationCurrentCount(totalNotificationCount - numberOfCurrentMessages)
    dispatch(setChatInfo(user));
    onClose();
    navigate('../connections');
  };

  const readNotification = (notificationId) => {
    mutate(
      {
        key: `users/${notificationId}/notification`,
        method: 'post',
      },
      {
        onSuccess(res) { },
      },
    );
  };

  const fetchOtherNotificationsForUser = () => {
    mutate(
      {
        key: `users/${loggedInUserId}/notification?page_no=1&page_size=10`,
        method: 'get',
      },
      {
        onSuccess(res) {
          let _messageTracker = {};
          setNotifications(
            res?.data?.notifications.filter(({ type, senderId, id }) => {
              if (type == 'message') {
                let { count = 0, ids = [] } = _messageTracker[senderId] || {};
                count += 1;
                ids = [...ids, id];
                _messageTracker[senderId] = {
                  count,
                  ids,
                };
              }
              return type == 'message'
                ? !_messageTracker[senderId] ||
                _messageTracker[senderId]?.count == 1
                : true;
            }),
          );

          setMessageTracker(_messageTracker);

        },
      },
    );
  };

  useEffect(() => {
    const fetchNotifications = () => {
      fetchOtherNotificationsForUser();
    };

    fetchNotifications();
    return () => {
      //clearInterval(intervalId);
    };
  }, [isOpen]);

  return (
    <>
      <Box>
        <Drawer onClose={onClose} isOpen={isOpen} size="lg">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader p={0}>
              <Box>
                <Flex h="60px" w="100%" bg="brand.primary" px={5}>
                  <Flex h="100%" w="100%" alignItems="center">
                    <Box display={{ base: 'none', md: 'flex' }}>
                      <HiOutlineArrowNarrowLeft
                        cursor="pointer"
                        size="30px"
                        color="white"
                        onClick={onClose}
                      />
                    </Box>

                    <Flex justifyContent="center" w="full">
                      <Text color="white">Notifications</Text>
                    </Flex>
                    <Box display={{ base: 'flex', md: 'none' }}>
                      <HiOutlineArrowNarrowLeft
                        cursor="pointer"
                        size="30px"
                        color="white"
                        onClick={onClose}
                      />
                    </Box>
                  </Flex>
                </Flex>
              </Box>
            </DrawerHeader>
            <DrawerBody p={0}>
              <Box p={4}>
                {isLoading ? (
                  <Spinner />
                ) : (
                  <>
                    {notifications.length > 0 ? (
                      notifications.map((notification) =>
                        notification.type === 'connection_request' ? (
                          <ConnectionRequestTabs
                            key={notification.id}
                            notifications={[
                              {
                                id: notification.id,
                                type: notification.type,
                                senderId: notification.sender.id,
                              },
                            ]}
                            onReadNotification={readNotification}
                            onClose={onClose}
                          />
                        ) : (
                          <Box key={notification.id} className="relative">
                            <Flex
                              border={
                                notification?.read == false
                                  ? '2px solid #134A70'
                                  : 'none'
                              }
                              mb={4}
                              px={4}
                              py={2}
                              justifyContent="space-between"
                              alignItems={'center'}
                              w="100%"
                              cursor={'pointer'}
                              boxShadow="0px 0px 4px lightgray"
                              onClick={() =>
                                notification?.type == 'message'
                                  ? chatWithConnection(
                                    notification?.sender,
                                    notification.id,
                                    notification?.type,
                                  )
                                  : goToLink(
                                    notification?.id,
                                    notification?.link,
                                    notification?.type,
                                  )
                              }
                            >
                              <Flex minW="60%" alignItems="center">
                                <Box mr={4} position="relative">
                                  <Avatar
                                    borderRadius="10px"
                                    name={`${notification?.sender?.first_name} ${notification?.sender?.last_name}`}
                                    src={notification?.sender?.profile_image}
                                    size={'sm'}
                                  />
                                  {!notification?.read && (
                                    <Box
                                      position="absolute"
                                      top="-2px"
                                      right="-2px"
                                      w="8px"
                                      h="8px"
                                      borderRadius="full"
                                      bg="blue.500"
                                    />
                                  )}
                                </Box>
                                <Box d="flex" flexDir="column">
                                  <Text
                                    fontWeight={500}
                                    fontSize={isDesktop ? '16px' : '12px'}
                                  >
                                    {`${notification?.sender?.first_name} ${notification?.sender?.last_name}`}
                                  </Text>
                                  {notification?.type !== 'message' ? (
                                    <Text fontWeight={500} fontSize={'14px'}>
                                      {notification?.title}
                                    </Text>
                                  ) : null}
                                  {notification?.type == 'message' ? (
                                    <Text
                                      fontWeight={300}
                                      fontSize={isDesktop ? '14px' : '12px'}
                                    >
                                      {notification?.message.substring(0, 22)}
                                      ...
                                    </Text>
                                  ) : null}

                                  {notification?.type === 'booking_rejected' ? (
                                    <Text
                                      fontWeight={300}
                                      fontSize={isDesktop ? '14px' : '12px'}
                                    >
                                      <span className="font-medium">
                                        Reason:
                                      </span>{' '}
                                      {notification?.message.split('_')[1] ||
                                        'Not specified'}
                                    </Text>
                                  ) : null}
                                </Box>
                              </Flex>
                              <Flex
                                justifyContent="space-between"
                                alignItems="center"
                                gap={2}
                              >
                                <Text
                                  fontWeight={500}
                                  fontSize={isDesktop ? '16px' : '12px'}
                                  whiteSpace="nowrap"
                                >
                                  {moment(notification.createdAt).fromNow()}
                                </Text>
                                {notification?.type == 'message' ? (
                                  <Box display={{ base: 'none', md: 'flex' }}>
                                    <BrandButton
                                      h="35px"
                                      text="Chat"
                                      width="100px"
                                      colorScheme="blue"
                                    />
                                  </Box>
                                ) : null}
                              </Flex>
                            </Flex>
                            {messageTracker[notification.senderId] &&
                              messageTracker[notification.senderId]?.count > 1 ? (
                              <Box className="w-fit absolute right-[-7px] top-[-10px] p-1.5 bg-gray-300 text-xs font-semibold rounded-full flex items-center justify-center">
                                {`+${messageTracker[notification.senderId]?.count}`}
                              </Box>
                            ) : null}
                          </Box>
                        ),
                      )
                    ) : (
                      <Box>You have no new notifications.</Box>
                    )}
                  </>
                )}
              </Box>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Box>
    </>
  );
};
export default Notifications;
